export class ShiftHandOver {
    constructor({
        id = null,        
        day = ``,
        shift = ``,
        locId = ``,
        locName = ``,
        handoverTime = ``,
        weather = ``,
        handoverManager = ``,
        handoverDutyMan = ``,
        dailyManager = ``,
        dailyDutyMan = ``,
        handoverMan =  ``,
        status = ``,
        runLog = [],
        editAble = null,
    } = {}) {
        this.id = id;
        this.day = day;
        this.shift = shift;
        this.locId = locId;
        this.locName = locName;
        this.handoverTime = handoverTime;
        this.weather = weather;
        this.handoverManager = handoverManager;
        this.handoverDutyMan = handoverDutyMan;
        this.dailyManager = dailyManager;
        this.dailyDutyMan = dailyDutyMan;
        this.handoverMan = handoverMan;
        this.status = status;
        this.runLog = runLog;
        this.editAble = editAble;
    }
}

export function gridFields() {
    return Object.freeze([        
        {
            key: 'day',
            label: 'lbl.shiftHandOver.day',
            sortable: true,
            form: {
                type: 'date'
            }
        },
        {
            key: 'locName',
            label: 'lbl.shiftHandOver.locName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'shift',
            label: 'lbl.shiftHandOver.shift',
            sortable: true,
            form: {
                type: 'select',
                options: [
                  { value: '1', text:  'lbl.shift.A' },
                  { value: '2', text:  'lbl.shift.B' },
                  { value: '3', text:  'lbl.shift.C' },
                ]
            }
        },
        {
            key: 'handoverTime',
            label: 'lbl.shiftHandOver.handoverTime',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'weather',
            label: 'lbl.shiftHandOver.weather',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'handoverManager',
            label: 'lbl.shiftHandOver.handoverManager',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'handoverDutyMan',
            label: 'lbl.shiftHandOver.handoverDutyMan',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'dailyManager',
            label: 'lbl.shiftHandOver.dailyManager',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'dailyDutyMan',
            label: 'lbl.shiftHandOver.dailyDutyMan',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'handoverMan',
            label: 'lbl.shiftHandOver.handoverMan',
            sortable: false,
            form: {
                type: 'input'
            }
        },
        {
            key: 'status',
            label: 'lbl.shiftHandOver.status',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    { value: null, text:  ''  },
                    {value: 0, text:"lbl.shiftHandOver.status.unHandover"},
                    {value: 1, text:"lbl.shiftHandOver.status.handovered"},
                  ]
              }
        },
        {
            key:'runLog',
            label:'lbl.shiftHandOver.runLog',
            sortable: false,
            form: {
                type: 'showcol'
            }
        }
    ])
}

export const fields = Object.freeze(Object.keys(new ShiftHandOver).map(i => 'entity.' + i));

export const filterFields = [
    'filter.statusFilter',
    'filter.plantFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',
    'filter.shiftFilter',
    'filter.editAbleFilter'
];

export const filter = {
    'statusFilter': "",
    'plantFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'shiftFilter': "",
    'editAbleFilter':""
};
